import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginComponent } from '../app/components/login/login.component' 
import { BussinssService } from 'src/app/services/bussinss-service';
import { DataService } from './services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  showFooter:boolean=true;
  login:boolean=true;
  static priceTotal="פריטים-0"
  static price=0;

  // constructor( private location: Location) { }

  constructor(private router: Router,private dataService: DataService) { }
 // isMainHome = true
  // ngOnInit() {
  //   debugger
  //   if(this.location.pathname =='/')
  //     this.isMainHome = true
  //   else
  //     this.isMainHome = false
  //    
  // }
  ngOnInit() {
    //localStorage.ACCESS_TOKEN  ="56134DF2-C779-49A5-A8EA-90693C611268"
   // localStorage.ACCESS_TOKEN  = "null";
    const pathname = window.location.pathname || '';
    const hash = window.location.hash || '';

    // If the app is loaded at the site root (no path) - navigate to mainHome
    // Also handle cases where hash routing is still used (e.g. #/mainHome)
    const isRootPath = pathname === '/' || pathname === '' || pathname === '/index.html';

    if (hash) {
      // If hash exists, prefer it for navigation (old behavior for hash routes)
      if (hash === '#/mainHome' || hash === '#/' ) {
        this.router.navigate(['/mainHome']);
      } else {
        const parts = hash.split('/', 3); // ['', 'route', 'maybeMore']
        if (parts.length > 1 && parts[1]) {
          this.router.navigate(['/' + parts[1]]);
        }
      }
    } else if (isRootPath) {
      // No hash and at root — navigate to mainHome once
      this.router.navigate(['/mainHome']);
    } else {
      // Do nothing: keep current pathname and let Angular Router handle it
    }
  }
}
